import { getGlobalCssUrl } from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createTemplateScaffoldTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
`
  return t
}

const getTemplateTemplateScaffoldStyles = () => createTemplateScaffoldTemplate()
export { getTemplateTemplateScaffoldStyles }
